
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue")
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("LL") : "";
    },
    date2(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      if (!val) return "";
      return String(val).formatMoney();
    }
  },
  computed: {
    lastOperations() {
      return JSON.parse(
        JSON.stringify((this as any).claim.claims_tracks)
      ).splice(0, 5);
    },
    subscriberTasks() {
      return (this as any).claim.claims_tracks
        ? (this as any).claim.claims_tracks.filter(
            (rt: any) => rt.subscriptorId
          )
        : [];
    },
    aonTasks() {
      return (this as any).claim.claims_tracks
        ? (this as any).claim.claims_tracks.filter((rt: any) => rt.adminId)
        : [];
    }
  }
})
export default class ClaimsDetail extends Vue {
  dictionary: any = {};
  statuses: any = [];
  paymentStatuses: any = ["Pendiente", "Aceptado", "Rechazado"];
  title: string = "";
  comment: string = "";
  modalText: string = "Siniestros";
  statusText: string = "";
  claim: any = {
    claims_details: [{}],
    subscriptor: {},
    request: {
      requests_details: [{}],
      currency: {},
      company: {}
    },
    claims_payments: [],
    claims_tracks: []
  };
  rows: any = [];
  countries: any = [];
  rowsEndoso: any = [];
  totalPaymentsDolar: any = {};
  totalPayments: any = {};

  statusClass(status) {
    if (status === 1) return "active";
    if (status === 0) return "pending";
    if (status === 8) return "pendingForEndorsement";
    return "inactive";
  }

  async mounted() {
    await this.loadDictionary();
    await this.loadStatuses();
    await this.loadClaim();
    this.loadCountries();
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  getCountry(id: string) {
    for (let i: number = 0; i < this.countries.length; i++) {
      if (parseInt(this.countries[i].id) === parseInt(id)) {
        return this.countries[i].title;
      }
    }
    return "";
  }

  showModal(id: number) {
    (this.$refs[`modal${id}`] as any).show();
  }

  exportPDF() {
    (document.querySelector("header.desktop") as any).style.display = "none";
    (document.querySelector(".footer") as any).style.display = "none";
    (document.querySelector("textarea") as any).style.display = "none";
    (document.querySelectorAll(".card-mobile") as any).forEach(ii => {
      ii.style.display = "none";
    });
    (document.querySelector(".cta") as any).style.display = "none";
    (document.querySelector(".menu-icon") as any).style.display = "none";
    (document.querySelector(".bell-icon") as any).style.display = "none";
    window.print();
    document.querySelector("header.desktop").removeAttribute("style");
    document.querySelector(".footer").removeAttribute("style");
    (document.querySelectorAll(".card-mobile") as any).forEach(ii => {
      ii.removeAttribute("style");
    });
    document.querySelector("textarea").removeAttribute("style");
    document.querySelector(".cta").removeAttribute("style");
    document.querySelector(".menu-icon").removeAttribute("style");
    document.querySelector(".bell-icon").removeAttribute("style");
  }

  async addNote() {
    try {
      const response: any = await (this.$root as any)._post(
        `claims/addnote/${this.$route.params.id}`,
        {
          note: this.comment
        }
      );
      this.comment = "";
      await this.loadClaim();
      (this.$root as any).notify("Se agrego el comentario con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo agregar el comentario.", "error");
    }
  }

  async loadClaim() {
    const response: any = await (this.$root as any)._post(
      `claims/one/${this.$route.params.id}`,
      {
        models: "claims_payments"
      }
    );
    this.claim = response.data[0];
    console.log("this.claim ",this.claim );
    this.title = `Detalle Siniestro ${this.claim.code}`;
    this.totalPaymentsDolar = response.data[0].claims_totals_payments ? response.data[0].claims_totals_payments.find(t => t.currencyId == 1) : {};
    this.totalPayments = response.data[0].claims_totals_payments ? response.data[0].claims_totals_payments.find(t => t.currencyId !== 1) : {};
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async approveRequest() {
    try {
      const response: any = await (this.$root as any)._get(
        `claims/changeadminstatus/${
          this.$route.params.id
        }/${this.statuses.indexOf("Procesada")}`
      );
      this.claim.status_admin = this.statuses.indexOf("Procesada");
      (this.$refs.modal1 as any).hide();
      this.statusText = `Siniestro aprobado`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify("No se pudo aprobar el siniestro.", "error");
    }
  }

  async rejectRequest() {
    try {
      const response: any = await (this.$root as any)._get(
        `claims/changeadminstatus/${
          this.$route.params.id
        }/${this.statuses.indexOf("No Procesada")}`
      );
      this.claim.status_admin = this.statuses.indexOf("No Procesada");
      (this.$refs.modal2 as any).hide();
      this.statusText = `Siniestro rechazado`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify("No se pudo rechazar el siniestro.", "error");
    }
  }

  reduce(key: string) {
    if (this.claim.claims_payments) {
      return this.claim.claims_payments.reduce(
        (acc, cur) => acc + (cur[key] ? parseFloat(cur[key]) : 0.0),
        0.0
      );
    } else {
      return 0;
    }
  }
}
